import actionDeleteModel      from '@widesk-ui/tools/actionModel/actionDeleteModel';
import actionEditModel        from '@widesk-ui/tools/actionModel/actionEditModel';
import actionAddModel         from '@widesk-ui/tools/actionModel/actionAddModel';
import actionEditManyModel    from '@widesk-ui/tools/actionModel/actionEditManyModel';
import actionUnlinkModel      from '@widesk-ui/tools/actionModel/actionUnlinkModel';
import actionDeleteCollection from '@widesk-ui/tools/actionModel/actionDeleteCollection';
import actionDuplicateModel   from '@widesk-ui/tools/actionModel/actionDuplicateModel';
import actionSeeHistoryModel  from '@widesk-ui/tools/actionModel/actionSeeHistoryModel';

export default {
	add: actionAddModel,
	duplicate: actionDuplicateModel,
	unlink: actionUnlinkModel,
	delete: actionDeleteModel,
	deleteCollection: actionDeleteCollection,
	edit: actionEditModel,
	editMany: actionEditManyModel,
	seeHistory: actionSeeHistoryModel,
};
